/**
 * Bestware Master Filter Engine - Version 7.3 (Product Tags Edition)
 */

(function() {
    if (window.BestwareEngineInitialized) return;
    window.BestwareEngineInitialized = true;

    let globalProductsCache = [];
    window.globalFilterConfig = null;
    const PRODUCTS_PER_PAGE = 12;
    let currentVisibleLimit = PRODUCTS_PER_PAGE;

    /*
     * Wartezeit, nach der eine manuelle Preiseingabe
     * ohne weiteren Tastendruck automatisch greift.
     */
    const PRICE_INPUT_COMMIT_DELAY = 1000;

    // --- Übersetzungs-Wörterbuch ---
    function getTranslations() {
        return window.BestwareFilterTranslations || {
            min: 'Von',
            max: 'Bis',
            clear: 'Alle entfernen',
            countString: '%%MATCHED%% von %%TOTAL%% Produkten',
            countStringSimple: '%%TOTAL%% Produkte',
            booleanTrue: 'Ja',
            booleanFalse: 'Nein'
        };
    }

    // --- Preis-Formatierer & Parser ---
    function formatPrice(val) {
        const lang = document.documentElement.lang.split('-')[0].toLowerCase();
        const num = parseFloat(val);

        if (isNaN(num)) return '';

        if (lang === 'de') {
            return num.toLocaleString('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) + ' €';
        }

        return num.toLocaleString('en-US', {
            useGrouping: false,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + ' €';
    }

    function parsePrice(str) {
        const lang = document.documentElement.lang.split('-')[0].toLowerCase();
        let cleaned = str.replace(/[^\d.,-]/g, '');

        if (lang === 'de') {
            cleaned = cleaned.replace(/\./g, '').replace(',', '.');
        } else {
            cleaned = cleaned.replace(/,/g, '');
        }

        return parseFloat(cleaned) || 0;
    }

    /*
     * Wert eines manuell befuellten Preisfeldes lesen.
     * Leere oder unlesbare Eingaben fallen auf den Grenzwert zurueck.
     */
    function readPriceInput(input, fallbackValue) {
        if (!input) return fallbackValue;

        const raw = input.value.trim();

        if (!/\d/.test(raw)) return fallbackValue;

        return parsePrice(raw);
    }

    // 1. Radikaler ID-Sanitizer
    const sanitizeId = (id) => {
        if (!id) return null;

        const stringId = id.toString();
        const parts = stringId.split('/');

        return parts[parts.length - 1].replace(/\D/g, '');
    };

    /**
     * Fasst native Shopify-Produkttypen anhand der JSON-Konfiguration
     * zu sichtbaren Produktart-Gruppen zusammen.
     *
     * Beispiel:
     * Laptop-Rucksack -> Taschen
     * Gaming-Maus -> Mäuse
     *
     * Produkttypen, die keiner Gruppe zugeordnet sind, werden unter ihrem
     * ursprünglichen Namen angezeigt.
     */
    function getProductTypeFilterValue(productType, config) {
        const rawValue = typeof productType === 'string'
            ? productType.trim()
            : '';

        if (!rawValue) return null;

        const groups = config?.groups;

        if (
            !groups ||
            typeof groups !== 'object' ||
            Array.isArray(groups)
        ) {
            return rawValue;
        }

        for (const [groupLabel, productTypes] of Object.entries(groups)) {
            if (
                Array.isArray(productTypes) &&
                productTypes.includes(rawValue)
            ) {
                return groupLabel;
            }
        }

        return rawValue;
    }

    /**
     * Liefert optional die für den sichtbaren Tag-Filter freigegebenen
     * Werte. Ohne allowedValues werden alle vorhandenen Produkttags
     * angezeigt und als Filterwert akzeptiert.
     */
    function getAllowedProductTags(config) {
        const configuredValues =
            config?.allowedValues;

        if (Array.isArray(configuredValues)) {
            return configuredValues
                .filter(value =>
                    typeof value === 'string' &&
                    value.trim() !== ''
                )
                .map(value => value.trim());
        }

        return null;
    }

    // 2. CSS FORCE INJECTION
    const style = document.createElement('style');

    style.innerHTML = `
        .bw-hidden {
            display: none !important;
        }

        #product-grid {
            opacity: 1 !important;
            visibility: visible !important;
        }

        #product-grid .js-filter-card:not(.bw-hidden) {
            opacity: 1 !important;
            visibility: visible !important;
            display: block !important;
        }

        .thb-filter-content {
            display: block !important;
        }

        .noUi-target {
            background: #eee !important;
            border-radius: 4px !important;
            height: 6px !important;
            border: none !important;
            box-shadow: none !important;
        }

        .noUi-connect {
            background: #000 !important;
        }

        .noUi-handle {
            width: 18px !important;
            height: 18px !important;
            border-radius: 100% !important;
            background: #fff !important;
            border: 2px solid #000 !important;
            cursor: pointer !important;
            box-shadow: none !important;
            right: -9px !important;
            top: -6px !important;
        }

        .noUi-handle::before,
        .noUi-handle::after {
            display: none !important;
        }

        details.thb-filter summary .icon-wrap {
            transform: none !important;
            transition: none !important;
        }

        details.thb-filter summary .icon-wrap svg {
            transform: rotate(0deg) !important;
            transition: transform 0.3s ease-in-out !important;
        }

        details.thb-filter[open] summary .icon-wrap svg {
            transform: rotate(180deg) !important;
        }

        select#SortByMobile,
        .facets__form select {
            padding-right: 35px !important;
            text-overflow: ellipsis !important;
            white-space: nowrap !important;
            overflow: hidden !important;
        }

        option[value="most-relevant"],
        button[data-value="most-relevant"],
        .custom-select--item:has(button[data-value="most-relevant"]),
        li:has(button[data-value="most-relevant"]) {
            display: none !important;
        }
    `;

    const noUiCss = document.createElement('link');

    noUiCss.rel = 'stylesheet';
    noUiCss.href =
        'https://cdnjs.cloudflare.com/ajax/libs/noUiSlider/15.7.1/nouislider.min.css';

    document.head.appendChild(noUiCss);
    document.head.appendChild(style);

    async function initBestwareFilter() {
        const container = document.getElementById('CustomFilterApp');

        if (!container) return;

        console.log(
            'Bestware Filter Engine v7.3 wird gestartet.'
        );

        const rawConfig = container.dataset.config;
        const collectionId = container.dataset.collectionId;
        const searchQuery = container.dataset.searchQuery;

        if (!collectionId && !searchQuery) return;

        let dynamicFilters = [];

        try {
            dynamicFilters = rawConfig
                ? JSON.parse(rawConfig)
                : [];

            if (typeof dynamicFilters === 'string') {
                dynamicFilters = JSON.parse(dynamicFilters);
            }

            if (
                !Array.isArray(dynamicFilters) ||
                dynamicFilters.length === 0
            ) {
                return;
            }
        } catch (error) {
            console.error(
                'Die Filterkonfiguration konnte nicht gelesen werden.',
                error
            );

            return;
        }

        window.globalFilterConfig = {
            token: 'c7b3acc71e33ac315f763348af171f2a',
            shop: window.location.hostname,
            filters: dynamicFilters,
            sectionId: container.dataset.sectionId,
            labels: {
                price: container.dataset.labelPrice || 'Preis',
                maxPrice:
                    container.dataset.labelMaxPrice ||
                    'Bis zu [price]'
            }
        };

        const currentLangString =
            document.documentElement.lang || 'de';

        const graphqlLangCode =
            currentLangString.split('-')[0].toUpperCase();

        const safeQuery = searchQuery
            ? searchQuery.replace(/"/g, '\\"')
            : '';

        /*
         * Neue Cache-Version.
         * Dadurch werden alte Cache-Einträge ohne productType ignoriert.
         */
        const cacheKey =
            `bw_filter_v73_${collectionId
                ? 'c_' + collectionId
                : 's_' + safeQuery
            }_${graphqlLangCode}`;

        const cachedData = sessionStorage.getItem(cacheKey);

        if (cachedData) {
            console.log('Filterdaten werden aus dem Cache geladen.');

            try {
                globalProductsCache = JSON.parse(cachedData);
            } catch (error) {
                console.warn(
                    'Der Filter-Cache ist ungültig und wird erneuert.',
                    error
                );

                sessionStorage.removeItem(cacheKey);
                globalProductsCache = [];
            }

            if (globalProductsCache.length > 0) {
                setTimeout(() => {
                    renderAllSidebars(
                        globalProductsCache,
                        window.globalFilterConfig
                    );

                    /*
                     * Das Produktraster wird beim ersten Aufruf nur bearbeitet,
                     * wenn bereits Filter in der URL aktiv sind.
                     */
                    const urlParams =
                        new URLSearchParams(window.location.search);

                    const hasActiveFilters =
                        Array.from(urlParams.keys()).some(
                            key =>
                                key.includes('filter.') ||
                                key === 'q'
                        );

                    if (hasActiveFilters) {
                        setTimeout(() => {
                            executeDOMFiltering(
                                window.globalFilterConfig
                            );

                            console.log(
                                'Filter Engine wurde aus dem Cache gestartet.'
                            );
                        }, 10);
                    } else {
                        console.log(
                            'Keine aktiven Filter. Das Produktraster bleibt beim Initial Load unverändert.'
                        );
                    }
                }, 10);

                return;
            }
        }

        /*
         * Nur echte Metafeldfilter werden über metafield() abgefragt.
         * price, vendor, product_type und tag sind native Shopify-Felder.
         */
        const metafieldQueries =
            window.globalFilterConfig.filters
                .map((filterConfig, index) => {
                    if (
                        [
                            'price',
                            'vendor',
                            'product_type',
                            'tag'
                        ].includes(filterConfig.type)
                    ) {
                        return '';
                    }

                    return `
                        f${index}: metafield(
                            namespace: "${filterConfig.namespace}",
                            key: "${filterConfig.key}"
                        ) {
                            value

                            reference {
                                ... on Metaobject {
                                    id
                                    handle

                                    fields {
                                        key
                                        value
                                    }
                                }
                            }

                            references(first: 25) {
                                nodes {
                                    ... on Metaobject {
                                        id
                                        handle

                                        fields {
                                            key
                                            value
                                        }
                                    }
                                }
                            }
                        }
                    `;
                })
                .join('\n');

        let query = '';

        if (searchQuery) {
            query = `
                query @inContext(language: ${graphqlLangCode}) {
                    products(
                        first: 250,
                        query: "${safeQuery}"
                    ) {
                        nodes {
                            id
                            title
                            handle
                            vendor
                            productType
                            tags

                            priceRange {
                                maxVariantPrice {
                                    amount
                                }
                            }

                            ${metafieldQueries}
                        }
                    }
                }
            `;
        } else if (collectionId) {
            const cleanId = collectionId.includes('gid://')
                ? collectionId
                : `gid://shopify/Collection/${collectionId}`;

            query = `
                query @inContext(language: ${graphqlLangCode}) {
                    node(id: "${cleanId}") {
                        ... on Collection {
                            products(first: 250) {
                                nodes {
                                    id
                                    title
                                    handle
                                    vendor
                                    productType
                                    tags

                                    priceRange {
                                        maxVariantPrice {
                                            amount
                                        }
                                    }

                                    ${metafieldQueries}
                                }
                            }
                        }
                    }
                }
            `;
        }

        try {
            console.log(
                'Produktdaten werden über die Shopify Storefront API geladen.'
            );

            const response = await fetch(
                `https://${window.globalFilterConfig.shop}/api/2024-04/graphql.json`,
                {
                    method: 'POST',
                    cache: 'no-cache',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token':
                            window.globalFilterConfig.token,
                        'Accept-Language': currentLangString
                    },
                    body: JSON.stringify({ query })
                }
            );

            const jsonResponse = await response.json();

            if (jsonResponse.errors?.length) {
                console.error(
                    'Die Shopify Storefront API hat Fehler zurückgegeben.',
                    jsonResponse.errors
                );

                return;
            }

            const fetchedProducts =
                jsonResponse.data?.products?.nodes ||
                jsonResponse.data?.node?.products?.nodes;

            if (!Array.isArray(fetchedProducts)) {
                console.error(
                    'Die Produktdaten konnten nicht aus der Storefront-API-Antwort gelesen werden.',
                    jsonResponse
                );

                return;
            }

            globalProductsCache = fetchedProducts;

            try {
                sessionStorage.setItem(
                    cacheKey,
                    JSON.stringify(fetchedProducts)
                );
            } catch (storageError) {
                console.warn(
                    'Der Browser-Cache ist voll. Die Filterdaten werden nicht zwischengespeichert.',
                    storageError
                );
            }

            setTimeout(() => {
                renderAllSidebars(
                    globalProductsCache,
                    window.globalFilterConfig
                );

                const urlParams =
                    new URLSearchParams(window.location.search);

                const hasActiveFilters =
                    Array.from(urlParams.keys()).some(
                        key => key.includes('filter.')
                    );

                if (hasActiveFilters) {
                    setTimeout(() => {
                        executeDOMFiltering(
                            window.globalFilterConfig
                        );

                        console.log(
                            'Filter Engine wurde erfolgreich gestartet.'
                        );
                    }, 10);
                } else {
                    console.log(
                        'Keine aktiven Filter. Das Produktraster bleibt beim Initial Load unverändert.'
                    );
                }
            }, 10);
        } catch (error) {
            console.error(
                'Fehler beim Initialisieren der Filter Engine:',
                error
            );
        }
    }

    /**
     * Berechnet die Anzahl der weiterhin möglichen Produkte je Filterwert.
     */
    function updateSidebarVisually(
        activeFilters,
        filtersActive
    ) {
        const valueCounts = {};

        window.globalFilterConfig.filters.forEach(
            (filterConfig, index) => {
                /*
                 * Nativer Herstellerfilter.
                 */
                if (filterConfig.type === 'vendor') {
                    const ignoredKey = 'filter.p.vendor';

                    globalProductsCache.forEach(product => {
                        if (
                            productMatchesFilters(
                                product,
                                activeFilters,
                                ignoredKey
                            )
                        ) {
                            const productVendor = product.vendor;

                            if (productVendor) {
                                valueCounts[productVendor] =
                                    (
                                        valueCounts[productVendor] ||
                                        0
                                    ) + 1;
                            }
                        }
                    });
                }

                /*
                 * Nativer Produkttypfilter.
                 * Die Produktarten werden anhand des JSON gruppiert.
                 */
                else if (
                    filterConfig.type === 'product_type'
                ) {
                    const ignoredKey =
                        'filter.p.product_type';

                    globalProductsCache.forEach(product => {
                        if (
                            productMatchesFilters(
                                product,
                                activeFilters,
                                ignoredKey
                            )
                        ) {
                            const visibleValue =
                                getProductTypeFilterValue(
                                    product.productType,
                                    filterConfig
                                );

                            if (visibleValue) {
                                valueCounts[visibleValue] =
                                    (
                                        valueCounts[visibleValue] ||
                                        0
                                    ) + 1;
                            }
                        }
                    });
                }

                /*
                 * Nativer Produkttagfilter.
                 * Mit allowedValues werden ausschließlich freigegebene
                 * Tags gezählt. Ohne Einschränkung werden alle gezählt.
                 */
                else if (filterConfig.type === 'tag') {
                    const ignoredKey = 'filter.p.tag';
                    const allowedTags =
                        getAllowedProductTags(filterConfig);

                    globalProductsCache.forEach(product => {
                        if (
                            productMatchesFilters(
                                product,
                                activeFilters,
                                ignoredKey
                            )
                        ) {
                            const productTags =
                                Array.isArray(product.tags)
                                    ? product.tags
                                    : [];

                            productTags.forEach(tag => {
                                if (
                                    !allowedTags ||
                                    allowedTags.includes(tag)
                                ) {
                                    valueCounts[tag] =
                                        (valueCounts[tag] || 0) + 1;
                                }
                            });
                        }
                    });
                }

                /*
                 * Reguläre Metafeldfilter.
                 */
                else if (filterConfig.type !== 'price') {
                    const productDataKey = `f${index}`;

                    globalProductsCache.forEach(product => {
                        if (
                            productMatchesFilters(
                                product,
                                activeFilters,
                                productDataKey
                            )
                        ) {
                            const productValues =
                                getProductValues(
                                    product[productDataKey]
                                );

                            productValues.forEach(value => {
                                if (value) {
                                    valueCounts[value] =
                                        (
                                            valueCounts[value] ||
                                            0
                                        ) + 1;
                                }
                            });
                        }
                    });
                }
            }
        );

        document
            .querySelectorAll('.custom-filter-input')
            .forEach(input => {
                const value = input.value;
                const listItem = input.closest('li');

                if (!listItem) return;

                const countElement =
                    listItem.querySelector('.count');

                const count = valueCounts[value] || 0;

                if (countElement) {
                    countElement.textContent = count;
                }

                if (
                    count === 0 &&
                    filtersActive &&
                    !input.checked
                ) {
                    input.disabled = true;
                    listItem.style.opacity = '0.4';
                    listItem.style.pointerEvents = 'none';
                } else {
                    input.disabled = false;
                    listItem.style.opacity = '1';
                    listItem.style.pointerEvents = 'auto';
                }
            });
    }

    /**
     * Filtert die bereits im DOM vorhandenen Produktkarten.
     */
    function executeDOMFiltering(
        config,
        urlParams = null,
        isSelfHealing = false
    ) {
        const activeFilters =
            getActiveFilters(config, urlParams);

        const filtersActive =
            Object.values(activeFilters).some(value => {
                if (Array.isArray(value)) {
                    return value.length > 0;
                }

                if (
                    value &&
                    typeof value === 'object'
                ) {
                    return value.min || value.max;
                }

                return false;
            });

        const matchingProductIds = new Set();

        globalProductsCache.forEach(product => {
            if (
                productMatchesFilters(
                    product,
                    activeFilters
                )
            ) {
                matchingProductIds.add(
                    sanitizeId(product.id)
                );
            }
        });

        const grid = document.getElementById('product-grid');

        if (!grid) {
            console.error(
                'Das Element #product-grid wurde nicht gefunden.'
            );

            return;
        }

        const cards =
            grid.querySelectorAll('.js-filter-card');

        /*
         * Wenn mehr Produkte auf den Filter passen, als aktuell im DOM
         * vorhanden sind, wird das Raster erneut von Shopify geladen.
         */
        if (
            matchingProductIds.size > cards.length &&
            !isSelfHealing
        ) {
            console.log(
                'Fehlende Produkte werden für die Filteransicht nachgeladen.'
            );

            grid.style.opacity = '0.5';

            fetch(window.location.href)
                .then(response => response.text())
                .then(html => {
                    const documentFromResponse =
                        new DOMParser().parseFromString(
                            html,
                            'text/html'
                        );

                    const newGrid =
                        documentFromResponse.getElementById(
                            'product-grid'
                        );

                    if (newGrid) {
                        grid.innerHTML = newGrid.innerHTML;
                        grid.style.opacity = '1';

                        executeDOMFiltering(
                            config,
                            urlParams,
                            true
                        );
                    }
                })
                .catch(error => {
                    console.error(
                        'Das Nachladen des Produktrasters ist fehlgeschlagen.',
                        error
                    );

                    grid.style.opacity = '1';
                });

            return;
        }

        let matchCounter = 0;

        cards.forEach(card => {
            const rawId = card.dataset.productId;
            const cardId = sanitizeId(rawId);

            if (
                cardId &&
                matchingProductIds.has(cardId)
            ) {
                matchCounter++;

                if (
                    !filtersActive &&
                    matchCounter > currentVisibleLimit
                ) {
                    card.classList.add('bw-hidden');
                } else {
                    card.classList.remove('bw-hidden');
                }
            } else {
                card.classList.add('bw-hidden');
            }
        });

        updateSidebarVisually(
            activeFilters,
            filtersActive
        );

        const countContainers = [
            document.getElementById(
                'EngineProductCountText'
            ),
            document.getElementById(
                'EngineProductCountTextMobile'
            )
        ];

        const translations = getTranslations();

        const totalProducts =
            Array.isArray(globalProductsCache)
                ? globalProductsCache.length
                : 0;

        const matchedProductsCount =
            matchingProductIds.size;

        countContainers.forEach(container => {
            if (!container) return;

            if (
                filtersActive &&
                matchedProductsCount !== totalProducts
            ) {
                container.textContent =
                    translations.countString
                        .replace(
                            '%%MATCHED%%',
                            matchedProductsCount
                        )
                        .replace(
                            '%%TOTAL%%',
                            totalProducts
                        );
            } else {
                container.textContent =
                    translations.countStringSimple
                        .replace(
                            '%%TOTAL%%',
                            totalProducts
                        );
            }
        });

        renderActiveFilters(activeFilters);

        updateLoadMoreButton(
            filtersActive,
            matchingProductIds.size
        );

        window.dispatchEvent(new Event('resize'));
    }

    /**
     * Rendert Desktop- und Mobilfilter.
     */
    async function renderAllSidebars(
        products,
        config
    ) {
        const sidebars = [
            document.getElementById(
                'CustomFilterSidebar'
            ),
            document.getElementById(
                'CustomFilterMobile'
            )
        ].filter(Boolean);

        if (sidebars.length === 0) return;

        const activeFilters =
            getActiveFilters(config);

        let maximumPrice = 0;

        products.forEach(product => {
            const amount = parseFloat(
                product.priceRange
                    ?.maxVariantPrice
                    ?.amount || 0
            );

            if (amount > maximumPrice) {
                maximumPrice = amount;
            }
        });

        let renderedCount = 0;
        let isFirstInjection = true;

        for (
            const [index, filterConfig]
            of config.filters.entries()
        ) {
            /*
             * Kurze Rendering-Pausen ab dem vierten Filter.
             */
            if (index >= 3) {
                await new Promise(resolve =>
                    setTimeout(resolve, 5)
                );
            }

            let groupHtml = '';

            /*
             * Preisfilter.
             */
            if (filterConfig.type === 'price') {
                const isPriceActive =
                    activeFilters.price &&
                    (
                        activeFilters.price.min ||
                        activeFilters.price.max
                    );

                const isOpen =
                    renderedCount < 3 ||
                    isPriceActive;

                groupHtml = renderPriceFilter(
                    filterConfig,
                    maximumPrice,
                    activeFilters.price,
                    isOpen
                );

                renderedCount++;
            }

            /*
             * Nativer Herstellerfilter.
             */
            else if (
                filterConfig.type === 'vendor'
            ) {
                const valuesMap = new Map();

                products.forEach(product => {
                    const value = product.vendor;

                    if (
                        value &&
                        value !== '' &&
                        !valuesMap.has(value)
                    ) {
                        valuesMap.set(value, {
                            label: value,
                            count: 0
                        });
                    }
                });

                products.forEach(product => {
                    if (
                        productMatchesFilters(
                            product,
                            activeFilters,
                            'filter.p.vendor'
                        )
                    ) {
                        const value = product.vendor;

                        if (valuesMap.has(value)) {
                            valuesMap.get(value).count++;
                        }
                    }
                });

                if (valuesMap.size > 0) {
                    const selectedValues =
                        activeFilters[
                            'filter.p.vendor'
                        ] || [];

                    const isActive =
                        selectedValues.length > 0;

                    const isOpen =
                        renderedCount < 3 ||
                        isActive;

                    groupHtml = renderFilterGroup(
                        filterConfig,
                        valuesMap,
                        'filter',
                        selectedValues,
                        isOpen
                    );

                    renderedCount++;
                }
            }

            /*
             * Nativer Produkttypfilter.
             */
            else if (
                filterConfig.type === 'product_type'
            ) {
                const valuesMap = new Map();

                /*
                 * Sichtbare Produktarten vorbereiten.
                 */
                products.forEach(product => {
                    const visibleValue =
                        getProductTypeFilterValue(
                            product.productType,
                            filterConfig
                        );

                    if (
                        visibleValue &&
                        !valuesMap.has(visibleValue)
                    ) {
                        valuesMap.set(visibleValue, {
                            label: visibleValue,
                            count: 0
                        });
                    }
                });

                /*
                 * Produktzahlen unter Berücksichtigung anderer Filter
                 * berechnen.
                 */
                products.forEach(product => {
                    if (
                        productMatchesFilters(
                            product,
                            activeFilters,
                            'filter.p.product_type'
                        )
                    ) {
                        const visibleValue =
                            getProductTypeFilterValue(
                                product.productType,
                                filterConfig
                            );

                        if (
                            visibleValue &&
                            valuesMap.has(visibleValue)
                        ) {
                            valuesMap
                                .get(visibleValue)
                                .count++;
                        }
                    }
                });

                if (valuesMap.size > 0) {
                    const selectedValues =
                        activeFilters[
                            'filter.p.product_type'
                        ] || [];

                    const isActive =
                        selectedValues.length > 0;

                    const isOpen =
                        renderedCount < 3 ||
                        isActive;

                    /*
                     * Mit prefix "filter", namespace "p" und
                     * key "product_type" erzeugt renderFilterGroup:
                     *
                     * filter.p.product_type
                     */
                    groupHtml = renderFilterGroup(
                        filterConfig,
                        valuesMap,
                        'filter',
                        selectedValues,
                        isOpen
                    );

                    renderedCount++;
                }
            }

            /*
             * Nativer Produkttagfilter. allowedValues kann die sichtbare
             * Auswahl bei Bedarf einschränken.
             */
            else if (filterConfig.type === 'tag') {
                const valuesMap = new Map();
                const allowedTags =
                    getAllowedProductTags(filterConfig);

                products.forEach(product => {
                    const productTags =
                        Array.isArray(product.tags)
                            ? product.tags
                            : [];

                    productTags.forEach(tag => {
                        if (
                            (!allowedTags ||
                                allowedTags.includes(tag)) &&
                            !valuesMap.has(tag)
                        ) {
                            valuesMap.set(tag, {
                                label: tag,
                                count: 0
                            });
                        }
                    });
                });

                products.forEach(product => {
                    if (
                        productMatchesFilters(
                            product,
                            activeFilters,
                            'filter.p.tag'
                        )
                    ) {
                        const productTags =
                            Array.isArray(product.tags)
                                ? product.tags
                                : [];

                        productTags.forEach(tag => {
                            if (valuesMap.has(tag)) {
                                valuesMap.get(tag).count++;
                            }
                        });
                    }
                });

                if (valuesMap.size > 0) {
                    const selectedValues =
                        activeFilters['filter.p.tag'] || [];

                    const isActive =
                        selectedValues.length > 0;

                    const isOpen =
                        renderedCount < 3 ||
                        isActive;

                    groupHtml = renderFilterGroup(
                        {
                            ...filterConfig,
                            namespace: 'p',
                            key: 'tag'
                        },
                        valuesMap,
                        'filter',
                        selectedValues,
                        isOpen
                    );

                    renderedCount++;
                }
            }

            /*
             * Reguläre Shopify- und Custom-Metafeldfilter.
             */
            else {
                const valuesMap = new Map();
                const productDataKey = `f${index}`;

                products.forEach(product => {
                    const field =
                        product[productDataKey];

                    if (!field) return;

                    /*
                     * Liste mit Metaobjekt-Referenzen.
                     */
                    if (
                        field.references
                            ?.nodes
                            ?.length > 0
                    ) {
                        field.references.nodes.forEach(
                            object => {
                                if (!object) return;

                                const label =
                                    object.fields?.find(
                                        objectField =>
                                            [
                                                'label',
                                                'name',
                                                'Label',
                                                'Name',
                                                'title',
                                                'Title',
                                                'wert',
                                                'Wert',
                                                'text',
                                                'Text',
                                                'value',
                                                'Value',
                                                'anzeigetext',
                                                'display_name',
                                                'filter_attribute'
                                            ].includes(
                                                objectField.key
                                            )
                                    )?.value ||
                                    object.handle ||
                                    'Unbenannt';

                                if (
                                    !valuesMap.has(object.id)
                                ) {
                                    valuesMap.set(
                                        object.id,
                                        {
                                            label,
                                            count: 0
                                        }
                                    );
                                }
                            }
                        );
                    }

                    /*
                     * Einzelne Metaobjekt-Referenz.
                     */
                    else if (field.reference) {
                        const object =
                            field.reference;

                        const label =
                            object.fields?.find(
                                objectField =>
                                    [
                                        'label',
                                        'name',
                                        'Label',
                                        'Name',
                                        'title',
                                        'Title',
                                        'wert',
                                        'Wert',
                                        'text',
                                        'Text',
                                        'value',
                                        'Value',
                                        'anzeigetext',
                                        'display_name',
                                        'filter_attribute'
                                    ].includes(
                                        objectField.key
                                    )
                            )?.value ||
                            object.handle ||
                            'Unbenannt';

                        if (!valuesMap.has(object.id)) {
                            valuesMap.set(
                                object.id,
                                {
                                    label,
                                    count: 0
                                }
                            );
                        }
                    }

                    /*
                     * Normaler Metafeldwert oder Liste einfacher Werte.
                     */
                    else if (field.value) {
                        getProductValues(field).forEach(
                            value => {
                                if (
                                    !valuesMap.has(value)
                                ) {
                                    valuesMap.set(
                                        value,
                                        {
                                            label: value,
                                            count: 0
                                        }
                                    );
                                }
                            }
                        );
                    }
                });

                products.forEach(product => {
                    if (
                        productMatchesFilters(
                            product,
                            activeFilters,
                            productDataKey
                        )
                    ) {
                        getProductValues(
                            product[productDataKey]
                        ).forEach(value => {
                            if (valuesMap.has(value)) {
                                valuesMap
                                    .get(value)
                                    .count++;
                            }
                        });
                    }
                });

                if (valuesMap.size > 0) {
                    const selectedValues =
                        activeFilters[
                            productDataKey
                        ] || [];

                    const isActive =
                        selectedValues.length > 0;

                    const isOpen =
                        renderedCount < 3 ||
                        isActive;

                    const prefix =
                        filterConfig.namespace ===
                        'shopify'
                            ? 'filter.v.t'
                            : 'filter.p.m';

                    groupHtml = renderFilterGroup(
                        filterConfig,
                        valuesMap,
                        prefix,
                        selectedValues,
                        isOpen
                    );

                    renderedCount++;
                }
            }

            /*
             * Erzeugte Filtergruppe in Desktop- und Mobil-Sidebar
             * einfügen.
             */
            if (groupHtml !== '') {
                sidebars.forEach(sidebar => {
                    if (isFirstInjection) {
                        sidebar.innerHTML = '';
                    }

                    const temporaryContainer =
                        document.createElement('div');

                    temporaryContainer.innerHTML =
                        groupHtml;

                    const element =
                        temporaryContainer
                            .firstElementChild;

                    if (!element) return;

                    element
                        .querySelectorAll(
                            '.custom-filter-input'
                        )
                        .forEach(input => {
                            input.addEventListener(
                                'change',
                                function() {
                                    const clones =
                                        document.querySelectorAll(
                                            `.custom-filter-input[data-key="${this.dataset.key}"][value="${this.value}"]`
                                        );

                                    clones.forEach(clone => {
                                        clone.checked =
                                            this.checked;
                                    });

                                    applyBestwareFilters(
                                        config
                                    );
                                }
                            );
                        });

                    sidebar.appendChild(element);
                });

                isFirstInjection = false;
            }
        }

        setTimeout(() => {
            initPriceSlider();
            initScrollFades();

            renderActiveFilters(
                getActiveFilters(config)
            );
        }, 50);
    }

    /**
     * Preisfilter rendern.
     */
    function renderPriceFilter(
        config,
        maximumPrice,
        active,
        isOpen
    ) {
        const translations = getTranslations();

        const minimumValue = active.min
            ? formatPrice(active.min)
            : '';

        const maximumValue = active.max
            ? formatPrice(active.max)
            : formatPrice(maximumPrice);

        return `
            <collapsible-row>
                <details
                    class="thb-filter js-filter"
                    ${isOpen ? 'open' : ''}
                >
                    <summary class="thb-filter-title">
                        ${window.globalFilterConfig.labels.price}

                        <span class="icon-wrap">
                            <svg
                                width="12"
                                height="7"
                                viewBox="0 0 12 7"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1 1L6 6L11 1"
                                    stroke="currentColor"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </span>
                    </summary>

                    <div
                        class="thb-filter-content collapsible__content"
                    >
                        <div class="price_range">
                            <div class="price_slider_wrapper">
                                <div
                                    class="price_slider"
                                    data-min-value="${active.min || 0}"
                                    data-min="0"
                                    data-max-value="${active.max || maximumPrice}"
                                    data-max="${maximumPrice}"
                                    data-step="5"
                                ></div>

                                <div
                                    class="price_slider_amount"
                                    style="
                                        display: flex;
                                        gap: 12px;
                                        margin-top: 20px;
                                        align-items: center;
                                        justify-content: space-between;
                                    "
                                >
                                    <div
                                        class="price_slider_amount__single"
                                        style="flex: 1;"
                                    >
                                        <input
                                            class="field__input field__input_min"
                                            value="${minimumValue}"
                                            type="text"
                                            placeholder="${translations.min}"
                                            style="
                                                width: 100%;
                                                text-align: center;
                                                padding: 10px;
                                            "
                                        >
                                    </div>

                                    <span style="color: #111;">
                                        -
                                    </span>

                                    <div
                                        class="price_slider_amount__single"
                                        style="flex: 1;"
                                    >
                                        <input
                                            class="field__input field__input_max"
                                            value="${maximumValue}"
                                            type="text"
                                            placeholder="${translations.max}"
                                            style="
                                                width: 100%;
                                                text-align: center;
                                                padding: 10px;
                                            "
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </details>
            </collapsible-row>
        `;
    }

    /**
     * Checkbox-Filtergruppe rendern.
     */
    function renderFilterGroup(
        config,
        valuesMap,
        prefix,
        activeValues,
        isOpen
    ) {
        const translations = getTranslations();

        const parameterKey =
            `${prefix}.${config.namespace}.${config.key}`;

        let items = '';

        const sortedValues =
            Array.from(valuesMap.entries()).sort(
                (first, second) =>
                    (
                        first[1].label || ''
                    ).localeCompare(
                        second[1].label || '',
                        'de',
                        {
                            numeric: true
                        }
                    )
            );

        for (
            const [value, data]
            of sortedValues
        ) {
            const isChecked =
                activeValues.includes(value);

            const isDisabled =
                data.count === 0 &&
                !isChecked;

            let displayLabel = data.label;

            if (config.type === 'boolean') {
                const lowerValue =
                    String(value).toLowerCase();

                if (lowerValue === 'true') {
                    displayLabel =
                        config.trueLabel
                            ? config.trueLabel
                            : translations.booleanTrue;
                }

                if (lowerValue === 'false') {
                    displayLabel =
                        config.falseLabel
                            ? config.falseLabel
                            : translations.booleanFalse;
                }
            }

            items += `
                <li
                    style="${
                        isDisabled
                            ? 'opacity: 0.4; pointer-events: none;'
                            : ''
                    }"
                >
                    <input
                        type="checkbox"
                        class="custom-filter-input"
                        value="${value}"
                        data-key="${parameterKey}"
                        data-label="${displayLabel}"
                        ${isChecked ? 'checked' : ''}
                    >

                    <label class="facet-checkbox">
                        <span>${displayLabel}</span>
                        <span class="count">${data.count}</span>
                    </label>
                </li>
            `;
        }

        return `
            <collapsible-row>
                <details
                    class="thb-filter js-filter"
                    ${isOpen ? 'open' : ''}
                >
                    <summary class="thb-filter-title">
                        ${config.label}

                        <span class="icon-wrap">
                            <svg
                                width="12"
                                height="7"
                                viewBox="0 0 12 7"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1 1L6 6L11 1"
                                    stroke="currentColor"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </span>
                    </summary>

                    <div
                        class="thb-filter-content collapsible__content"
                    >
                        <ul class="list-unstyled">
                            ${items}
                        </ul>
                    </div>
                </details>
            </collapsible-row>
        `;
    }

    /**
     * Preis-Slider initialisieren.
     */
    function initPriceSlider() {
        const sliderElements =
            document.querySelectorAll(
                '.price_slider'
            );

        if (sliderElements.length === 0) return;

        if (typeof noUiSlider === 'undefined') {
            console.error(
                'noUiSlider ist nicht verfügbar.'
            );

            return;
        }

        sliderElements.forEach(sliderElement => {
            if (sliderElement.noUiSlider) {
                sliderElement.noUiSlider.destroy();
            }

            const absoluteMinimum =
                parseFloat(
                    sliderElement.dataset.min
                ) || 0;

            const absoluteMaximum =
                parseFloat(
                    sliderElement.dataset.max
                ) || 1000;

            const startMinimum =
                parseFloat(
                    sliderElement.dataset.minValue
                ) || absoluteMinimum;

            const startMaximum =
                parseFloat(
                    sliderElement.dataset.maxValue
                ) || absoluteMaximum;

            noUiSlider.create(sliderElement, {
                start: [
                    startMinimum,
                    startMaximum
                ],
                connect: true,
                step: 5,
                range: {
                    min: absoluteMinimum,
                    max: absoluteMaximum
                },
                format: {
                    to: value =>
                        parseFloat(value).toFixed(2),

                    from: value =>
                        parseFloat(value)
                }
            });

            const wrapper =
                sliderElement.closest(
                    '.price_slider_wrapper'
                );

            if (!wrapper) return;

            const minimumInput =
                wrapper.querySelector(
                    '.field__input_min'
                );

            const maximumInput =
                wrapper.querySelector(
                    '.field__input_max'
                );

            sliderElement.noUiSlider.on(
                'update',
                (values, handle) => {
                    if (
                        handle === 0 &&
                        minimumInput
                    ) {
                        minimumInput.value =
                            formatPrice(values[0]);
                    } else if (maximumInput) {
                        maximumInput.value =
                            formatPrice(values[1]);
                    }
                }
            );

            sliderElement.noUiSlider.on(
                'change',
                () => {
                    const currentValues =
                        sliderElement
                            .noUiSlider
                            .get();

                    document
                        .querySelectorAll(
                            '.price_slider'
                        )
                        .forEach(otherSlider => {
                            if (
                                otherSlider !==
                                    sliderElement &&
                                otherSlider.noUiSlider
                            ) {
                                otherSlider
                                    .noUiSlider
                                    .set(currentValues);
                            }
                        });

                    applyBestwareFilters(
                        window.globalFilterConfig
                    );
                }
            );

            bindPriceInputs(
                sliderElement,
                minimumInput,
                maximumInput
            );
        });
    }

    /**
     * Beide Preisfelder eines Sliders auf dessen
     * aktuelle Werte schreiben.
     */
    function writePriceInputs(sliderElement) {
        if (!sliderElement.noUiSlider) return;

        const wrapper =
            sliderElement.closest(
                '.price_slider_wrapper'
            );

        if (!wrapper) return;

        const values =
            sliderElement.noUiSlider.get();

        const minimumInput =
            wrapper.querySelector(
                '.field__input_min'
            );

        const maximumInput =
            wrapper.querySelector(
                '.field__input_max'
            );

        if (minimumInput) {
            minimumInput.value =
                formatPrice(values[0]);
        }

        if (maximumInput) {
            maximumInput.value =
                formatPrice(values[1]);
        }
    }

    /**
     * Manuelle Preiseingabe aktivieren.
     * Ohne diese Bindung sind die Felder unter dem
     * Slider reine Anzeigefelder.
     */
    function bindPriceInputs(
        sliderElement,
        minimumInput,
        maximumInput
    ) {
        const inputs = [
            minimumInput,
            maximumInput
        ].filter(Boolean);

        if (inputs.length === 0) return;

        const absoluteMinimum =
            parseFloat(
                sliderElement.dataset.min
            ) || 0;

        const absoluteMaximum =
            parseFloat(
                sliderElement.dataset.max
            ) || 1000;

        const step =
            parseFloat(
                sliderElement.dataset.step
            ) || 5;

        function clampToRange(value) {
            return Math.min(
                Math.max(value, absoluteMinimum),
                absoluteMaximum
            );
        }

        /*
         * isAutoSubmit ist true, wenn der Filter nach
         * einer Tipp-Pause automatisch greift. Slider
         * und Schreibweise werden dann genauso
         * aktualisiert wie bei Enter oder Feldwechsel;
         * nur wenn sich nichts aendert, bleibt die
         * laufende Eingabe unangetastet.
         */
        function commitPriceInputs(isAutoSubmit) {
            if (!sliderElement.noUiSlider) return;

            /*
             * Auf die Slider-Schrittweite runden:
             * Minimum abwaerts, Maximum aufwaerts,
             * damit die eingetippte Spanne nie
             * eingeengt wird.
             */
            let nextMinimum = clampToRange(
                Math.floor(
                    readPriceInput(
                        minimumInput,
                        absoluteMinimum
                    ) / step
                ) * step
            );

            let nextMaximum = clampToRange(
                Math.ceil(
                    readPriceInput(
                        maximumInput,
                        absoluteMaximum
                    ) / step
                ) * step
            );

            if (nextMinimum > nextMaximum) {
                const swap = nextMinimum;

                nextMinimum = nextMaximum;
                nextMaximum = swap;
            }

            const currentValues =
                sliderElement.noUiSlider.get();

            const unchanged =
                Math.abs(
                    parseFloat(currentValues[0]) -
                        nextMinimum
                ) < 0.01 &&
                Math.abs(
                    parseFloat(currentValues[1]) -
                        nextMaximum
                ) < 0.01;

            if (unchanged) {
                if (isAutoSubmit) return;

                // Nur die Schreibweise normalisieren.
                writePriceInputs(sliderElement);

                return;
            }

            sliderElement.noUiSlider.set([
                nextMinimum,
                nextMaximum
            ]);

            const values =
                sliderElement.noUiSlider.get();

            document
                .querySelectorAll(
                    '.price_slider'
                )
                .forEach(otherSlider => {
                    if (
                        otherSlider !==
                            sliderElement &&
                        otherSlider.noUiSlider
                    ) {
                        otherSlider
                            .noUiSlider
                            .set(values);
                    }

                    writePriceInputs(otherSlider);
                });

            applyBestwareFilters(
                window.globalFilterConfig
            );
        }

        /*
         * Auto-Absenden nach Tipp-Pause.
         */
        let commitTimer = null;

        function scheduleCommit() {
            window.clearTimeout(commitTimer);

            commitTimer = window.setTimeout(
                () => commitPriceInputs(true),
                PRICE_INPUT_COMMIT_DELAY
            );
        }

        inputs.forEach(input => {
            if (
                input.dataset.bestwarePriceBound ===
                'true'
            ) {
                return;
            }

            input.dataset.bestwarePriceBound =
                'true';

            input.setAttribute(
                'inputmode',
                'decimal'
            );

            // Automatisch nach einer Sekunde Tipp-Pause.
            input.addEventListener(
                'input',
                () => scheduleCommit()
            );

            // Feuert bei Verlassen des Feldes.
            input.addEventListener(
                'change',
                () => {
                    window.clearTimeout(commitTimer);

                    commitPriceInputs(false);
                }
            );

            input.addEventListener(
                'keydown',
                event => {
                    if (event.key !== 'Enter') return;

                    event.preventDefault();

                    window.clearTimeout(commitTimer);

                    commitPriceInputs(false);

                    input.blur();
                }
            );

            // Formatierten Wert direkt ueberschreibbar machen.
            input.addEventListener(
                'focus',
                () => input.select()
            );
        });
    }

    /**
     * Aktive Filter aus der URL lesen.
     */
    function getActiveFilters(
        config,
        urlParams = null
    ) {
        const params =
            urlParams ||
            new URLSearchParams(
                window.location.search
            );

        return {
            price: {
                min:
                    params.get(
                        'filter.v.price.gte'
                    ) || '',

                max:
                    params.get(
                        'filter.v.price.lte'
                    ) || ''
            },

            ...config.filters.reduce(
                (
                    accumulator,
                    filterConfig,
                    index
                ) => {
                    /*
                     * Nativer Herstellerfilter.
                     */
                    if (
                        filterConfig.type ===
                        'vendor'
                    ) {
                        const values =
                            params.getAll(
                                'filter.p.vendor'
                            );

                        if (values.length > 0) {
                            accumulator[
                                'filter.p.vendor'
                            ] = values;
                        }
                    }

                    /*
                     * Nativer Produkttypfilter.
                     */
                    else if (
                        filterConfig.type ===
                        'product_type'
                    ) {
                        const values =
                            params.getAll(
                                'filter.p.product_type'
                            );

                        if (values.length > 0) {
                            accumulator[
                                'filter.p.product_type'
                            ] = values;
                        }
                    }

                    /*
                     * Nativer Produkttagfilter.
                     */
                    else if (
                        filterConfig.type ===
                        'tag'
                    ) {
                        const allowedTags =
                            getAllowedProductTags(
                                filterConfig
                            );

                        const values =
                            params
                                .getAll(
                                    'filter.p.tag'
                                )
                                .filter(value =>
                                    !allowedTags ||
                                    allowedTags.includes(value)
                                );

                        if (values.length > 0) {
                            accumulator[
                                'filter.p.tag'
                            ] = values;
                        }
                    }

                    /*
                     * Reguläre Metafeldfilter.
                     */
                    else if (
                        filterConfig.type !==
                        'price'
                    ) {
                        const values = [
                            ...params.getAll(
                                `filter.v.t.${filterConfig.namespace}.${filterConfig.key}`
                            ),

                            ...params.getAll(
                                `filter.p.m.${filterConfig.namespace}.${filterConfig.key}`
                            )
                        ];

                        if (values.length > 0) {
                            accumulator[
                                `f${index}`
                            ] = values;
                        }
                    }

                    return accumulator;
                },
                {}
            )
        };
    }

    /**
     * Prüft, ob ein Produkt alle aktiven Filter erfüllt.
     *
     * ignoreKey wird für die dynamischen Zähler verwendet.
     * Der aktuell gezählte Filter wird dabei ignoriert.
     */
    function productMatchesFilters(
        product,
        activeFilters,
        ignoreKey = null
    ) {
        /*
         * Preisfilter.
         */
        if (
            activeFilters.price.min ||
            activeFilters.price.max
        ) {
            const productPrice = parseFloat(
                product.priceRange
                    ?.maxVariantPrice
                    ?.amount || 0
            );

            if (
                activeFilters.price.min &&
                productPrice <
                    parseFloat(
                        activeFilters.price.min
                    )
            ) {
                return false;
            }

            if (
                activeFilters.price.max &&
                productPrice >
                    parseFloat(
                        activeFilters.price.max
                    )
            ) {
                return false;
            }
        }

        for (
            const [key, values]
            of Object.entries(activeFilters)
        ) {
            if (
                key === 'price' ||
                key === ignoreKey ||
                values.length === 0
            ) {
                continue;
            }

            /*
             * Nativer Herstellerfilter.
             */
            if (key === 'filter.p.vendor') {
                const productVendor =
                    product.vendor;

                if (
                    !values.includes(
                        productVendor
                    )
                ) {
                    return false;
                }

                continue;
            }

            /*
             * Nativer Produkttypfilter.
             */
            if (
                key ===
                'filter.p.product_type'
            ) {
                const productTypeConfig =
                    window.globalFilterConfig
                        ?.filters
                        ?.find(
                            filterConfig =>
                                filterConfig.type ===
                                'product_type'
                        );

                const rawProductType =
                    typeof product.productType ===
                    'string'
                        ? product.productType.trim()
                        : '';

                const groupedProductType =
                    getProductTypeFilterValue(
                        rawProductType,
                        productTypeConfig
                    );

                /*
                 * Unterstützt den sichtbaren Gruppenwert:
                 * Taschen
                 *
                 * sowie einen direkten Rohwert:
                 * Laptop-Tasche
                 */
                if (
                    !values.includes(
                        groupedProductType
                    ) &&
                    !values.includes(
                        rawProductType
                    )
                ) {
                    return false;
                }

                continue;
            }

            /*
             * Nativer Produkttagfilter.
             */
            if (key === 'filter.p.tag') {
                const tagFilterConfig =
                    window.globalFilterConfig
                        ?.filters
                        ?.find(
                            filterConfig =>
                                filterConfig.type === 'tag'
                        );

                const allowedTags =
                    getAllowedProductTags(
                        tagFilterConfig
                    );

                const validSelectedTags =
                    allowedTags
                        ? values.filter(value =>
                            allowedTags.includes(value)
                        )
                        : values;

                const productTags =
                    Array.isArray(product.tags)
                        ? product.tags
                        : [];

                if (
                    validSelectedTags.length === 0 ||
                    !validSelectedTags.some(tag =>
                        productTags.includes(tag)
                    )
                ) {
                    return false;
                }

                continue;
            }

            /*
             * Reguläre Metafeldfilter.
             */
            const productValues =
                getProductValues(product[key]);

            if (
                !values.some(value =>
                    productValues.includes(value)
                )
            ) {
                return false;
            }
        }

        return true;
    }

    /**
     * Liest einfache Metafeldwerte und Metaobjekt-Referenzen.
     */
    function getProductValues(field) {
        if (!field) return [];

        if (
            field.references
                ?.nodes
                ?.length > 0
        ) {
            return field.references.nodes
                .filter(Boolean)
                .map(object => object.id);
        }

        if (field.value) {
            try {
                const parsedValue =
                    JSON.parse(field.value);

                if (
                    Array.isArray(parsedValue)
                ) {
                    return parsedValue;
                }
            } catch (error) {
                /*
                 * Normaler Einzelwert. Keine Aktion erforderlich.
                 */
            }

            return [field.value];
        }

        return [];
    }

    /**
     * Überträgt die im UI ausgewählten Filter in die URL
     * und startet anschließend die DOM-Filterung.
     */
    function applyBestwareFilters(config) {
        const params =
            new URLSearchParams(
                window.location.search
            );

        const keysToDelete = [];

        params.forEach((value, key) => {
            if (key.startsWith('filter.')) {
                keysToDelete.push(key);
            }
        });

        keysToDelete.forEach(key => {
            params.delete(key);
        });

        const seenFilters = new Set();

        document
            .querySelectorAll(
                '.custom-filter-input:checked'
            )
            .forEach(checkbox => {
                const uniqueId =
                    checkbox.dataset.key +
                    '||' +
                    checkbox.value;

                if (!seenFilters.has(uniqueId)) {
                    seenFilters.add(uniqueId);

                    params.append(
                        checkbox.dataset.key,
                        checkbox.value
                    );
                }
            });

        const sliders =
            document.querySelectorAll(
                '.price_slider'
            );

        let changedMinimum = null;
        let changedMaximum = null;

        sliders.forEach(slider => {
            if (!slider.noUiSlider) return;

            const values =
                slider.noUiSlider.get();

            const currentMinimum =
                parseFloat(values[0]);

            const currentMaximum =
                parseFloat(values[1]);

            const absoluteMinimum =
                parseFloat(
                    slider.dataset.min
                ) || 0;

            const absoluteMaximum =
                parseFloat(
                    slider.dataset.max
                ) || 1000;

            if (
                currentMinimum >
                absoluteMinimum + 0.1
            ) {
                changedMinimum =
                    currentMinimum;
            }

            if (
                currentMaximum <
                absoluteMaximum - 0.1
            ) {
                changedMaximum =
                    currentMaximum;
            }
        });

        if (changedMinimum !== null) {
            params.set(
                'filter.v.price.gte',
                changedMinimum
            );
        }

        if (changedMaximum !== null) {
            params.set(
                'filter.v.price.lte',
                changedMaximum
            );
        }

        const queryString = params.toString();

        const newRelativePath =
            queryString
                ? `${window.location.pathname}?${queryString}`
                : window.location.pathname;

        history.pushState(
            null,
            '',
            newRelativePath
        );

        executeDOMFiltering(
            config,
            params
        );
    }

    /**
     * Rendert die aktiven Filter als Badges.
     */
    function renderActiveFilters(
        activeFilters
    ) {
        const container =
            document.getElementById(
                'BestwareActiveFilters'
            );

        if (!container) return;

        const translations = getTranslations();

        let html = '';

        const params =
            new URLSearchParams(
                window.location.search
            );

        let hasFilters = false;

        params.forEach((value, key) => {
            if (!key.startsWith('filter.')) {
                return;
            }

            hasFilters = true;

            let displayValue = value;

            if (key.includes('price')) {
                if (
                    key ===
                    'filter.v.price.gte'
                ) {
                    displayValue =
                        `${translations.min}: ${formatPrice(value)}`;
                }

                if (
                    key ===
                    'filter.v.price.lte'
                ) {
                    displayValue =
                        `${translations.max}: ${formatPrice(value)}`;
                }
            } else {
                const checkbox =
                    Array.from(
                        document.querySelectorAll(
                            `.custom-filter-input[data-key="${key}"]`
                        )
                    ).find(
                        input =>
                            input.value === value
                    );

                if (
                    checkbox &&
                    checkbox.dataset.label
                ) {
                    displayValue =
                        checkbox.dataset.label;
                } else {
                    displayValue =
                        decodeURIComponent(value);
                }
            }

            const safeHtmlValue =
                String(value)
                    .replace(/&/g, '&amp;')
                    .replace(/"/g, '&quot;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;');

            const safeDisplayValue =
                String(displayValue)
                    .replace(/&/g, '&amp;')
                    .replace(/"/g, '&quot;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;');

            html += `
                <a
                    href="#"
                    class="active-facets__button js-remove-filter"
                    data-key="${key}"
                    data-value="${safeHtmlValue}"
                >
                    ${safeDisplayValue}

                    <span>
                        <svg
                            width="10"
                            height="10"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1 1L13 13M1 13L13 1"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                            />
                        </svg>
                    </span>
                </a>
            `;
        });

        if (hasFilters) {
            html += `
                <a
                    href="#"
                    class="active-facets__button-remove text-button js-clear-all-filters"
                >
                    ${translations.clear}
                </a>
            `;
        }

        container.innerHTML = html;
        container.style.display =
            hasFilters
                ? 'block'
                : 'none';

        container
            .querySelectorAll(
                '.js-remove-filter'
            )
            .forEach(button => {
                button.addEventListener(
                    'click',
                    function(event) {
                        event.preventDefault();

                        const key =
                            this.dataset.key;

                        const value =
                            this.dataset.value;

                        if (
                            key.includes('price')
                        ) {
                            document
                                .querySelectorAll(
                                    '.price_slider'
                                )
                                .forEach(slider => {
                                    if (
                                        !slider.noUiSlider
                                    ) {
                                        return;
                                    }

                                    const absoluteMinimum =
                                        parseFloat(
                                            slider.dataset.min
                                        ) || 0;

                                    const absoluteMaximum =
                                        parseFloat(
                                            slider.dataset.max
                                        ) || 1000;

                                    if (
                                        key.includes('gte')
                                    ) {
                                        slider
                                            .noUiSlider
                                            .set([
                                                absoluteMinimum,
                                                null
                                            ]);
                                    } else if (
                                        key.includes('lte')
                                    ) {
                                        slider
                                            .noUiSlider
                                            .set([
                                                null,
                                                absoluteMaximum
                                            ]);
                                    }
                                });
                        } else {
                            document
                                .querySelectorAll(
                                    `.custom-filter-input[data-key="${key}"]`
                                )
                                .forEach(checkbox => {
                                    if (
                                        checkbox.value ===
                                        value
                                    ) {
                                        checkbox.checked =
                                            false;
                                    }
                                });
                        }

                        applyBestwareFilters(
                            window.globalFilterConfig
                        );
                    }
                );
            });

        const clearButton =
            container.querySelector(
                '.js-clear-all-filters'
            );

        if (clearButton) {
            clearButton.addEventListener(
                'click',
                event => {
                    event.preventDefault();

                    document
                        .querySelectorAll(
                            '.custom-filter-input'
                        )
                        .forEach(checkbox => {
                            checkbox.checked = false;
                        });

                    document
                        .querySelectorAll(
                            '.price_slider'
                        )
                        .forEach(slider => {
                            if (
                                !slider.noUiSlider
                            ) {
                                return;
                            }

                            const absoluteMinimum =
                                parseFloat(
                                    slider.dataset.min
                                ) || 0;

                            const absoluteMaximum =
                                parseFloat(
                                    slider.dataset.max
                                ) || 1000;

                            slider.noUiSlider.set([
                                absoluteMinimum,
                                absoluteMaximum
                            ]);
                        });

                    applyBestwareFilters(
                        window.globalFilterConfig
                    );
                }
            );
        }
    }

    /**
     * Virtuellen "Mehr laden"-Button aktualisieren.
     */
    function updateLoadMoreButton(
        filtersActive,
        total
    ) {
        const container =
            document.getElementById(
                'ProductPaginationContainer'
            );

        if (!container) return;

        if (
            filtersActive ||
            total <= currentVisibleLimit
        ) {
            container.style.display = 'none';
            return;
        }

        container.style.display = 'flex';
        container.style.justifyContent = 'center';
        container.style.marginTop = '30px';

        const buttonText =
            window.themeTranslations
                ?.load_more ||
            'Mehr laden';

        container.innerHTML = `
            <button
                id="VirtualLoadMore"
                class="button"
            >
                ${buttonText}
            </button>
        `;

        document
            .getElementById(
                'VirtualLoadMore'
            )
            ?.addEventListener(
                'click',
                () => {
                    currentVisibleLimit +=
                        PRODUCTS_PER_PAGE;

                    executeDOMFiltering(
                        window.globalFilterConfig
                    );
                }
            );
    }

    /**
     * Scroll-Indikatoren der Filterlisten initialisieren.
     */
    function initScrollFades() {
        const lists =
            document.querySelectorAll(
                '.thb-filter-content ul'
            );

        lists.forEach(list => {
            const checkScroll = () => {
                const isScrollable =
                    list.scrollHeight >
                    list.clientHeight;

                if (!isScrollable) {
                    list.classList.remove(
                        'can-scroll-top',
                        'can-scroll-bottom'
                    );

                    return;
                }

                const isAtTop =
                    list.scrollTop <= 0;

                const isAtBottom =
                    Math.abs(
                        list.scrollHeight -
                        list.scrollTop -
                        list.clientHeight
                    ) < 2;

                if (isAtTop) {
                    list.classList.remove(
                        'can-scroll-top'
                    );

                    list.classList.add(
                        'can-scroll-bottom'
                    );
                } else if (isAtBottom) {
                    list.classList.add(
                        'can-scroll-top'
                    );

                    list.classList.remove(
                        'can-scroll-bottom'
                    );
                } else {
                    list.classList.add(
                        'can-scroll-top',
                        'can-scroll-bottom'
                    );
                }
            };

            checkScroll();

            list.addEventListener(
                'scroll',
                checkScroll
            );
        });
    }

    /**
     * Sortierbuttons initialisieren.
     */
    function initSorting() {
        const sortButtons =
            document.querySelectorAll(
                '.custom-select--item button'
            );

        if (sortButtons.length === 0) return;

        sortButtons.forEach(button => {
            button.addEventListener(
                'click',
                function(event) {
                    event.preventDefault();

                    const params =
                        new URLSearchParams(
                            window.location.search
                        );

                    params.set(
                        'sort_by',
                        this.dataset.value
                    );

                    window.location.search =
                        params.toString();
                }
            );
        });
    }

    /**
     * Mobilen Filter-Drawer initialisieren.
     */
    function initMobileDrawer() {
        const toggleButtons =
            document.querySelectorAll(
                '.facets-toggle'
            );

        const drawer =
            document.getElementById(
                'Facet-Drawer'
            );

        const clickCapture =
            document.querySelector(
                '.click-capture'
            );

        const closeTriggers =
            document.querySelectorAll(
                'side-panel-close, .mobile-filters-apply, .click-capture'
            );

        if (
            toggleButtons.length === 0 ||
            !drawer
        ) {
            return;
        }

        toggleButtons.forEach(button => {
            button.addEventListener(
                'click',
                event => {
                    event.preventDefault();
                    event.stopPropagation();

                    drawer.classList.add(
                        'active',
                        'is-active'
                    );

                    document.body.classList.add(
                        'overflow-hidden',
                        'open-cc'
                    );

                    if (clickCapture) {
                        clickCapture.classList.add(
                            'active',
                            'is-active'
                        );
                    }
                }
            );
        });

        closeTriggers.forEach(button => {
            button.addEventListener(
                'click',
                () => {
                    drawer.classList.remove(
                        'active',
                        'is-active'
                    );

                    document.body.classList.remove(
                        'overflow-hidden',
                        'open-cc'
                    );

                    if (clickCapture) {
                        clickCapture.classList.remove(
                            'active',
                            'is-active'
                        );
                    }
                }
            );
        });
    }

    /*
     * Mobile Sortierung.
     */
    document.addEventListener(
        'change',
        event => {
            if (
                event.target &&
                event.target.id ===
                    'SortByMobile'
            ) {
                const params =
                    new URLSearchParams(
                        window.location.search
                    );

                params.set(
                    'sort_by',
                    event.target.value
                );

                window.location.search =
                    params.toString();
            }
        }
    );

    /*
     * Klick auf das sichtbare Checkbox-Label.
     */
    document.addEventListener(
        'click',
        event => {
            const label =
                event.target.closest(
                    '.facet-checkbox'
                );

            if (!label) return;

            event.preventDefault();

            const listItem =
                label.closest('li');

            if (!listItem) return;

            const checkbox =
                listItem.querySelector(
                    '.custom-filter-input, input[type="checkbox"]'
                );

            if (!checkbox) return;

            checkbox.checked =
                !checkbox.checked;

            if (
                typeof applyBestwareFilters ===
                'function'
            ) {
                applyBestwareFilters(
                    window.globalFilterConfig
                );
            } else {
                checkbox.dispatchEvent(
                    new Event(
                        'change',
                        {
                            bubbles: true
                        }
                    )
                );
            }
        }
    );

    /*
     * Browsernavigation zurück und vor unterstützen.
     */
    window.addEventListener(
        'popstate',
        () => {
            if (!window.globalFilterConfig) return;

            renderAllSidebars(
                globalProductsCache,
                window.globalFilterConfig
            );

            executeDOMFiltering(
                window.globalFilterConfig
            );
        }
    );

    // --- START-BLOCK INNERHALB DER ENGINE ---
    window.bootBestwareEngine = function() {
        initMobileDrawer();
        initPriceSlider();
        initSorting();
        initBestwareFilter();
    };
})();

/*
 * Smart Boot.
 * Bei vorhandenen URL-Filtern startet die Engine sofort.
 * Sonst wartet sie kurz auf den ersten sichtbaren Seitenaufbau.
 */
console.log(
    'Bestware Filter Engine JavaScript wurde geladen.'
);

window.startEngineSafely = function() {
    if (window.BestwareEngineBooted) return;

    window.BestwareEngineBooted = true;

    console.log(
        'Bestware Filter Engine wird initialisiert.'
    );

    if (
        typeof window.bootBestwareEngine ===
        'function'
    ) {
        window.bootBestwareEngine();
    }
};

const urlParamsCheck =
    new URLSearchParams(
        window.location.search
    );

const needsImmediateBoot =
    Array.from(
        urlParamsCheck.keys()
    ).some(
        key =>
            key.includes('filter.') ||
            key === 'q'
    );

if (needsImmediateBoot) {
    if (
        document.readyState ===
        'loading'
    ) {
        document.addEventListener(
            'DOMContentLoaded',
            window.startEngineSafely
        );
    } else {
        window.startEngineSafely();
    }
} else {
    const bootWithDelay = () => {
        setTimeout(
            window.startEngineSafely,
            500
        );
    };

    if (
        document.readyState ===
        'loading'
    ) {
        document.addEventListener(
            'DOMContentLoaded',
            bootWithDelay
        );
    } else {
        bootWithDelay();
    }
}
